import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { color, font } from "../tokens";
import { STATIC_MODE } from "../primitives";

const BOOT_LINE = "~ % elbert.init() · resume v2 loaded";

const Strip = styled.div`
  background: ${color.ink};
  color: ${color.paper};
  font-family: ${font.mono};
  font-size: 12.5px;
  font-weight: 500;
  letter-spacing: 0.06em;
  padding: 16px clamp(20px, 5vw, 72px);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const blink = keyframes`
  0%, 49% { opacity: 1; }
  50%, 100% { opacity: 0; }
`;

const Cursor = styled.span`
  display: inline-block;
  width: 7px;
  height: 14px;
  margin-left: 3px;
  vertical-align: -2px;
  background: ${color.accent};
  animation: ${blink} 1.1s step-end infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

/** Slim terminal strip — types once on load, never scroll-driven. */
const BootStrip: React.FC = () => {
  const [chars, setChars] = useState(() =>
    STATIC_MODE ||
    (typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches)
      ? BOOT_LINE.length
      : 0,
  );

  useEffect(() => {
    if (chars >= BOOT_LINE.length) return;
    const id = window.setInterval(() => {
      setChars((c) => {
        if (c >= BOOT_LINE.length) {
          window.clearInterval(id);
          return c;
        }
        return c + 1;
      });
    }, 32);
    return () => window.clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Strip role="presentation" aria-hidden>
      <span>
        {BOOT_LINE.slice(0, chars)}
        <Cursor />
      </span>
    </Strip>
  );
};

export default BootStrip;
